<template>
  <div class="recharge-list-box">
    <div class="action-bar">
      <div class="recharge-list-box">
        <!--操作栏-->
        <div class="action-bar">
          <el-input
            size="small"
            clearable
            placeholder="商区码"
            v-model="params.discCode"
            @change="getDailyList('status')"
            class="param-input"
          />
          <el-select
            v-model="params.discType"
            size="small"
            placeholder="请选择商区类型"
            clearable
            @change="getDailyList('status')"
          >
            <el-option
              v-for="(item, i) in discTypeList"
              :value="item.value"
              :label="item.label"
              :key="i"
            ></el-option>
          </el-select>
          <el-input
            size="small"
            clearable
            placeholder="账号"
            v-model="params.name"
            @change="getDailyList('status')"
            class="param-input"
          />
          <el-input
            size="small"
            clearable
            placeholder="备注"
            v-model="params.remark"
            @change="getDailyList('status')"
            class="param-input"
          />
          <el-date-picker
            v-model="time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            @change="changeTime"
          ></el-date-picker>

          <el-button type="primary" size="small" @click="getDailyList('status')">搜索</el-button>
          <el-button type="primary" size="small" @click="exportdata">导出</el-button>
          <div>
            <el-checkbox v-model="isDed" label="切换到扣量" @click="isExpandOne"></el-checkbox>
            <el-checkbox
              v-model="isShow"
              v-if="params.discType!==1"
              label="展示直推和裂变"
              @click="isExpand"
            ></el-checkbox>
          </div>
        </div>
        <!--数据表格-->
        <el-table
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column
            fixed
            prop="sumDate"
            :label="lableMap.sumDate"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.sumDate === '总共'">{{scope.row.sumDate}}</span>
              <span v-else>{{scope.row.sumDate| changeMd }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed
            prop="districtCode"
            :label="lableMap.districtCode"
            align="center"
            min-width="160"
          >
            <template slot-scope="scope">
              <span>{{scope.row.districtCode || ' '}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="discType" label="商区类型" align="center" min-width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.discType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name" :label="lableMap.name" align="center" min-width="160">
            <template slot-scope="scope">
              <span>{{scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" :label="lableMap.remark" align="center" min-width="160">
            <template slot-scope="scope">
              <span>{{scope.row.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="lableMap.newUIDCount" align="center" min-width="100">
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.newUIDCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.newUIDCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="newDirectUIDCount"
            :label="lableMap.newDirectUIDCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.newDirectUIDCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.newDirectUIDCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="newFissionUIDCount"
            :label="lableMap.newFissionUIDCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.newFissionUIDCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.newFissionUIDCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="rechargeCompleteOrderCount"
            :label="lableMap.rechargeCompleteOrderCount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.rechargeCompleteOrderCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.rechargeCompleteOrderCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directRechargePaidOrderCount"
            :label="lableMap.directRechargePaidOrderCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directRechargePaidOrderCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directRechargePaidOrderCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionRechargePaidOrderCount"
            :label="lableMap.fissionRechargePaidOrderCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionRechargePaidOrderCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionRechargePaidOrderCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="rechargeCompleteOrderAmount"
            :label="lableMap.rechargeCompleteOrderAmount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.rechargeCompleteOrderAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.rechargeCompleteOrderAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directRechargePaidAmount"
            :label="lableMap.directRechargePaidAmount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directRechargePaidAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directRechargePaidAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionRechargePaidAmount"
            :label="lableMap.fissionRechargePaidAmount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionRechargePaidAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionRechargePaidAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="newAndRechargeOrderCount"
            :label="lableMap.newAndRechargeOrderCount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{ scope.row.dedDailyData.newAndRechargeOrderCount |fixed2}}</span>
              <span v-else>{{ scope.row.dailyData.newAndRechargeOrderCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="newAndRechargeOrderYuan"
            :label="lableMap.newAndRechargeOrderYuan"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{ scope.row.dedDailyData.newAndRechargeOrderYuan |fixed2}}</span>
              <span v-else>{{ scope.row.dailyData.newAndRechargeOrderYuan |fixed2}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="userFissionRatio"
            :label="lableMap.userFissionRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.userFissionRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.userFissionRatio |fixed2}}</span>
            </template>
          </el-table-column>-->
          <el-table-column
            prop="buyVIPCount"
            :label="lableMap.buyVIPCount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.buyVIPCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.buyVIPCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directBuyVIPCount"
            :label="lableMap.directBuyVIPCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directBuyVIPCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directBuyVIPCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionBuyVIPCount"
            :label="lableMap.fissionBuyVIPCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionBuyVIPCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionBuyVIPCount |fixed2}}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="buyVIPAmount"
            :label="lableMap.buyVIPAmount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.buyVIPAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.buyVIPAmount |fixed2}}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="directBuyVIPAmount"
            :label="lableMap.directBuyVIPAmount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directBuyVIPAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directBuyVIPAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionBuyVIPAmount"
            :label="lableMap.fissionBuyVIPAmount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionBuyVIPAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionBuyVIPAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="buyVIPUIDCount"
            :label="lableMap.buyVIPUIDCount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.buyVIPUIDCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.buyVIPUIDCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directBuyVIPUIDCount"
            :label="lableMap.directBuyVIPUIDCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directBuyVIPUIDCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directBuyVIPUIDCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionBuyVIPUIDCount"
            :label="lableMap.fissionBuyVIPUIDCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionBuyVIPUIDCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionBuyVIPUIDCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="buyVIDTaxAmount"
            :label="lableMap.buyVIDTaxAmount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.buyVIDTaxAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.buyVIDTaxAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directBuyVIDTaxAmount"
            :label="lableMap.directBuyVIDTaxAmount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directBuyVIDTaxAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directBuyVIDTaxAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionBuyVIDTaxAmount"
            :label="lableMap.fissionBuyVIDTaxAmount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionBuyVIDTaxAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionBuyVIDTaxAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="consume" :label="lableMap.consume" align="center" min-width="100">
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.consume |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.consume |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directConsume"
            :label="lableMap.directConsume"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directConsume |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directConsume |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionConsume"
            :label="lableMap.fissionConsume"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionConsume |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionConsume |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="arpu" :label="lableMap.arpu" align="center" min-width="100">
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.arpu |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.arpu |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directARPU"
            :label="lableMap.directARPU"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directARPU |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directARPU |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionARPU"
            :label="lableMap.fissionARPU"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionARPU |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionARPU |fixed2}}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="withDrawOrderCount" :label="lableMap.withDrawOrderCount" align="center" min-width="100">
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.withDrawOrderCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.withDrawOrderCount |fixed2}}</span>
            </template>
          </el-table-column>-->
          <!-- <el-table-column prop="withDrawOrderAmount" :label="lableMap.withDrawOrderAmount" align="center" min-width="100">
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.withDrawOrderAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.withDrawOrderAmount |fixed2}}</span>
            </template>
          </el-table-column>-->
          <el-table-column
            prop="withDrawCompleteOrderCount"
            :label="lableMap.withDrawCompleteOrderCount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.withDrawCompleteOrderCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.withDrawCompleteOrderCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="withDrawCompleteOrderAmount"
            :label="lableMap.withDrawCompleteOrderAmount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.withDrawCompleteOrderAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.withDrawCompleteOrderAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="withDrawPaidOrderCount"
            :label="lableMap.withDrawPaidOrderCount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.withDrawPaidOrderCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.withDrawPaidOrderCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directWithDrawPaidOrderCount"
            :label="lableMap.directWithDrawPaidOrderCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directWithDrawPaidOrderCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directWithDrawPaidOrderCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionWithDrawPaidOrderCount"
            :label="lableMap.fissionWithDrawPaidOrderCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionWithDrawPaidOrderCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionWithDrawPaidOrderCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="withDrawPaidAmount"
            :label="lableMap.withDrawPaidAmount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.withDrawPaidAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.withDrawPaidAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directWithDrawPaidAmount"
            :label="lableMap.directWithDrawPaidAmount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directWithDrawPaidAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directWithDrawPaidAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionWithDrawPaidAmount"
            :label="lableMap.fissionWithDrawPaidAmount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionWithDrawPaidAmount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionWithDrawPaidAmount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="visitUIDCount"
            :label="lableMap.visitUIDCount"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.visitUIDCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.visitUIDCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directVisitUIDCount"
            :label="lableMap.directVisitUIDCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directVisitUIDCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directVisitUIDCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionVisitUIDCount"
            :label="lableMap.fissionVisitUIDCount"
            align="center"
            min-width="100"
            v-if="isShow"
            :key="Math.random()"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionVisitUIDCount |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionVisitUIDCount |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="nextDayRetainUIDRatio"
            :label="lableMap.nextDayRetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.nextDayRetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.nextDayRetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="day3RetainUIDRatio"
            :label="lableMap.day3RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.day3RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.day3RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="day7RetainUIDRatio"
            :label="lableMap.day7RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.day7RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.day7RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="day15RetainUIDRatio"
            :label="lableMap.day15RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.day15RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.day15RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="day30RetainUIDRatio"
            :label="lableMap.day30RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.day30RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.day30RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directNextDayRetainUIDRatio"
            :label="lableMap.directNextDayRetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directNextDayRetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directNextDayRetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directDay3RetainUIDRatio"
            :label="lableMap.directDay3RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directDay3RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directDay3RetainUIDRatio |fixed2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directDay7RetainUIDRatio"
            :label="lableMap.directDay7RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directDay7RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directDay7RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directDay15RetainUIDRatio"
            :label="lableMap.directDay15RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directDay15RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directDay15RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="directDay30RetainUIDRatio"
            :label="lableMap.directDay30RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.directDay30RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.directDay30RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionNextDayRetainUIDRatio"
            :label="lableMap.fissionNextDayRetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionNextDayRetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionNextDayRetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionDay3RetainUIDRatio"
            :label="lableMap.fissionDay3RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionDay3RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionDay3RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionDay7RetainUIDRatio"
            :label="lableMap.fissionDay7RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionDay7RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionDay7RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionDay15RetainUIDRatio"
            :label="lableMap.fissionDay15RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionDay15RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionDay15RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fissionDay30RetainUIDRatio"
            :label="lableMap.fissionDay30RetainUIDRatio"
            align="center"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="isDed">{{scope.row.dedDailyData.fissionDay30RetainUIDRatio |fixed2}}</span>
              <span v-else>{{scope.row.dailyData.fissionDay30RetainUIDRatio |fixed2}}</span>
              <span>%</span>
            </template>
          </el-table-column>

          <!-- <el-table-column :label="lableMap." align="center" fixed="right" width="130">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="editDesc(scope.row)"></el-button>
        </template>
          </el-table-column>-->
        </el-table>
        <el-pagination
          :page-sizes="[10, 15, 20, 25]"
          :current-page="params.pageNumber"
          :page-size="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          v-if="total > 10"
          @size-change="changeSize"
          @current-change="changeCurrent"
        ></el-pagination>
      </div>
      <div class="zw"></div>
    </div>
  </div>
</template>
<script>
import { changeTime } from "@/utils/global";
import API from "@/api";
import { paramsFilter } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import * as define from "./define";
import local from "@/utils/localStroage";
export default {
  data() {
    return {
      showMap: {},
      isDed: false,
      isShow: false,
      sum: {},
      list: [],
      total: 0,
      dialogVisible: false,
      tableData: [],
      time: "",
      loading: false,
      rchgordMoney: 0,
      lableMap: define.LableMap,
      // 请求订单列表参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        discCode: "", //商区码
      },
      discTypeList: [
        { label: "cps", value: 0 },
        { label: "cpa", value: 1 },
        { label: "cpt", value: 2 },
        { label: "cpc", value: 3 },
      ],
    };
  },
  filters: {
    filtersDividendRatio(params) {
      if (params) {
        return params + "%";
      }
      return "";
    },
  },
  created() {
    let actJson = local.get("userInfo").actJson
      ? JSON.parse(local.get("userInfo").actJson)
      : {};
    this.initShowMap(actJson.checked);
    this.initShowMap(actJson.halfChecked);
    this.getDailyList();
  },
  methods: {
    //初始化显示项
    initShowMap(actJson) {
      if (!actJson) return false;
      for (let k in actJson) {
        let auth = actJson[k];
        if (auth.children) {
          this.initShowMap(auth.children);
        }
        if (typeof auth === "string") {
          this.showMap[auth] = true;
        } else {
          this.showMap[auth.name] = true;
        }
      }
    },
    //根据勾选权限判断是否显示
    hasItemAuth(key) {
      if (!this.showMap[key]) return false;
      return this.showMap[key];
    },

    isExpand() {
      this.isShow = this.isShow ? false : true;
    },
    isExpandOne() {
      this.isDed = this.isDed ? false : true;
    },
    // 请求订单统计列表
    getDailyList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      let params = Object.assign({}, this.params, {
        srd: this.hasItemAuth("isRealData2"),
      });
      API.getDailyList(params)
        .then((res) => {
          if (res.code === 200 && res.data.list.length !== 0) {
            // this.tableData = []
            this.sum = {
              sumDate: "总共",
              districtCode: "",
              seqe: "",
              dividendRatio: "",
              name: "",
              dailyData: res.data.sum,
              dedDailyData: res.data.dedSum,
            };
            this.tableData = res.data.list;
            this.tableData.unshift(this.sum);

            this.total = res.data.total;
            this.sum = res.data.sum;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 导出数据
    exportdata() {
      let params = paramsFilter({
        ...this.params,
        lableMap: JSON.stringify(this.lableMap),
        srd: this.hasItemAuth("isExport1"),
      });
      let str = "";
      for (let key in params) {
        if (key == "startTime" || key == "endTime") {
          params[key] = params[key].replace("+", "%2B");
        }
        str += key + "=" + params[key] + "&";
      }
      str = str.substring(0, str.length - 1);
      let url = baseConfig.baseServerUrl + "/export/disc/acc/list?" + str;
      window.location.href = url;
    },

    // 打开弹窗
    open(row) {
      this.dialogVisible = true;
      this.params.agent = row.agent;
      this.params.discCode = row.districtCode;
      this.getDailyList();
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.params = {
        pageNumber: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        seqe: "",
        discCode: "", //商区码
        // sysType: "" //系统类型
      };
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size;
      this.getDailyList();
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getDailyList();
    },
    // 时间选择回掉
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || "";
        this.params.endTime = changeTime(time[1]) || "";
      } else {
        this.params.startTime = "";
        this.params.endTime = "";
      }
      this.getDailyList("status");
    },
  },
};
</script>
<style lang="scss">
.zw {
  height: 100px;
}
.recharge-list-box tbody tr.el-table__row:first-child {
  background: #ccc;
  font-weight: 700;
}
</style>

